import "core-js/modules/es.array.push.js";
import { toRef, ref, watch, computed } from 'vue';
export default {
  name: "PagesPC",
  props: {
    page: {
      type: Number,
      default: 1
    },
    total_page: {
      type: Number,
      default: 1
    },
    pageUrlTemplate: {
      type: String,
      default: '{page}'
    },
    // 只有一頁時要不顯示跳頁功能
    showJumpWithOnlyOnePages: {
      type: Boolean,
      default: true
    }
  },
  setup(props, target) {
    let page = toRef(props, 'page');
    // 手動輸入頁碼
    let inputPage = ref('');
    // 往前頁碼區間起始頁碼
    let start = ref(beforeMinPage(page.value));
    // 往後頁碼區間結束頁碼
    let end = ref(afterMaxPage(page.value));
    // 顯示的頁數
    let displayPage = ref(page.value);
    watch(() => page.value, data => {
      displayPage.value = controlPage(data);
      start.value = beforeMinPage(displayPage.value);
      end.value = afterMaxPage(displayPage.value);
    });

    // 顯示第一頁按鈕
    let showFirst = computed(() => start.value >= 2);

    // 顯示前一頁按鈕
    let showPrev = computed(() => props.page > 1);

    // 往前頁碼
    let beforePages = computed(() => {
      let ary = [];
      for (let i = start.value; i < displayPage.value; i++) ary.push(i);
      return ary;
    });

    // 往後頁碼
    let afterPages = computed(() => {
      let ary = [];
      for (let i = displayPage.value + 1; i <= end.value; i++) ary.push(i);
      return ary;
    });

    // 顯示點點點
    let showDot = computed(() => end.value <= props.total_page - 1);

    // 顯示最末頁按鈕
    let showLast = computed(() => end.value < props.total_page);

    // 顯示下一頁按鈕
    let showNext = computed(() => props.page < props.total_page);

    // 計算往前頁碼區間最小頁碼
    function beforeMinPage(page) {
      return Math.max(Math.min(page - 2, props.total_page - 4), 1);
    }

    // 計算往後頁碼區間最大頁碼
    function afterMaxPage(page) {
      return Math.min(Math.max(page + 2, 5), props.total_page);
    }

    // 防止頁碼超出範圍
    function controlPage(page) {
      let realPage;
      if (page < 1) {
        realPage = 1;
      } else if (page > props.total_page) {
        realPage = props.total_page;
      } else {
        realPage = page;
      }
      return realPage;
    }

    // 前往輸入的頁數
    let togoPage = page => {
      inputPage.value = ''; // 清空輸入框數字
      target.emit("updatePage", controlPage(page));
    };
    return {
      displayPage,
      start,
      inputPage,
      showFirst,
      showPrev,
      beforePages,
      afterPages,
      showDot,
      showLast,
      showNext,
      togoPage,
      controlPage
    };
  }
};